module.exports = __webpack_public_path__ + "1a8430e3bd11736cc8bccca967efd014.pdf";